const $$splitComponentImporter = () => import('/app/src/routes/grupne-terapije/payment-result.$outcome.$enrollment.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Monri return URL of a group-therapy enrollment. Our ids live in the path;
// the query string belongs to Monri and is ignored.
export const Route = createFileRoute("/grupne-terapije/payment-result/$outcome/$enrollment")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});